import Axios from 'axios'

import type {
  TCreateDashboardFolderRequest,
  TCreateDashboardFolderResponse,
  TDashboardFolderDto,
  TUpdateDashboardFolderRequest,
  TUpdateDashboardFolderResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/dashboard-folders`

export async function create(body: TCreateDashboardFolderRequest) {
  return Axios.post<TCreateDashboardFolderResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function getAll() {
  return getWithRedirect<TDashboardFolderDto[]>(URL)
}

export async function update(id: string, body: TUpdateDashboardFolderRequest) {
  return Axios.patch<TUpdateDashboardFolderResponse>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
